// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"aCYCr","background-$(backgroundColor)":"bCYCr","external":"cCYCr","headingContent":"dCYCr","paragraph":"eCYCr"};